module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    ref: "swiperComponent",
    staticClass: "vue-carousel",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('swiper-slide', {
      key: index
    }, [(_vm.slides.length === 1) ? [_c('div', {
      staticClass: "slide-content is-active"
    }, [_c('div', {
      staticClass: "slide-title"
    }, [_vm._v("\n        " + _vm._s(slide.title) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "slide-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImage(slide.thumb)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "slide-description",
      domProps: {
        "innerHTML": _vm._s(slide.description)
      }
    })])] : [_c('div', {
      class: ['slide-content', {
        'is-active': index === _vm.currentSliderIndex
      }],
      on: {
        "click": function($event) {
          _vm.currentSliderIndex = index
        }
      }
    }, [_c('div', {
      staticClass: "slide-title"
    }, [_vm._v("\n        " + _vm._s(slide.title) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "slide-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImage(slide.thumb)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "slide-description",
      domProps: {
        "innerHTML": _vm._s(slide.description)
      }
    })])]], 2)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a099ab2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/slider.vue
// module id = 571
// module chunks = 0